import { ITestSession, TestSessionOptions } from '../../interfaces/core/ITestSession';

export class TestSession implements ITestSession {
  private _completed = false;
  private _error?: Error;

  constructor(
    public readonly id: string,
    public readonly label: string,
    public readonly options: TestSessionOptions
  ) {}

  get completed(): boolean {
    return this._completed;
  }

  get error(): Error | undefined {
    return this._error;
  }

  markCompleted(): void {
    this._completed = true;
  }

  setError(error: Error): void {
    this._error = error;
  }

  static createId(label: string): string {
    return `session_${label.toLowerCase().replace(/\s+/g, '_')}_${Date.now()}`;
  }

  static getDefaultOptions(): TestSessionOptions {
    return {
      timeout: 5000,
      retries: 0,
      metadata: {}
    };
  }
}
